import {
  E_COURSE_ITEM_API,
  PHYSICAL_PRODUCT_ITEM_API,
  PRODUCT_ITEM_API,
  getCourseItemPostPath,
  getPhysicalProductItemPostPath,
  getProductItemPostPath,
} from 'modules/stores/api/stores-api'
import {
  PhysicalProductItemUpdateType,
  PhysicalProductItemViewType,
  ProductDownloadItemUpdateType,
  ProductDownloadItemViewType,
  ProductECourseItemUpdateType,
  ProductECourseItemViewType,
} from 'modules/stores/store/content/product/types/product-interface'
import { usePublisherErrorHandler } from 'modules/stores/store/hooks/use-publisher-error-handler'
import { StoreId } from 'modules/stores/types/stores-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useItemProductActions = () => {
  const { internalErrorHandler } = usePublisherErrorHandler()

  const { fetcher: postFetcher } = useFetch<RequestMethodsEnum.post, ProductDownloadItemViewType>({
    method: RequestMethodsEnum.post,
    unprocessableContentHandler: () => {},
    internalErrorHandler,
  })
  const { fetcher: putFetcher } = useFetch<RequestMethodsEnum.put, ProductDownloadItemViewType>({
    method: RequestMethodsEnum.put,
    unprocessableContentHandler: () => {},
    internalErrorHandler,
  })
  const { fetcher: deleteFetcher } = useFetch({
    method: RequestMethodsEnum.delete,
  })

  const { fetcher: postECourseFetcher } = useFetch<
    RequestMethodsEnum.post,
    ProductECourseItemViewType
  >({
    method: RequestMethodsEnum.post,
    unprocessableContentHandler: () => {},
    internalErrorHandler,
  })
  const { fetcher: putECourseFetcher } = useFetch<
    RequestMethodsEnum.put,
    ProductECourseItemViewType
  >({
    method: RequestMethodsEnum.put,
    unprocessableContentHandler: () => {},
    internalErrorHandler,
  })

  const { fetcher: postPhysicalProductFetcher } = useFetch<
    RequestMethodsEnum.post,
    PhysicalProductItemViewType
  >({
    method: RequestMethodsEnum.post,
    unprocessableContentHandler: () => {},
    internalErrorHandler,
  })
  const { fetcher: putPhysicalProductFetcher } = useFetch<
    RequestMethodsEnum.put,
    PhysicalProductItemViewType
  >({
    method: RequestMethodsEnum.put,
    unprocessableContentHandler: () => {},
    internalErrorHandler,
  })

  const createProduct = (storeId: StoreId, data: ProductDownloadItemUpdateType) =>
    postFetcher(getProductItemPostPath(storeId), data)
  const updateProduct = (id: number, data: ProductDownloadItemUpdateType) =>
    putFetcher(`${PRODUCT_ITEM_API}/${id}`, data)
  const deleteProductItem = (id: number) => deleteFetcher(`${PRODUCT_ITEM_API}/${id}`)

  const createECourse = (storeId: StoreId, data: ProductECourseItemUpdateType) =>
    postECourseFetcher(getCourseItemPostPath(storeId), data)
  const updateECourse = (id: number, data: ProductECourseItemUpdateType) =>
    putECourseFetcher(`${E_COURSE_ITEM_API}/${id}`, data)
  const deleteECourseItem = (id: number) => deleteFetcher(`${E_COURSE_ITEM_API}/${id}`)

  const createPhysicalProduct = (storeId: StoreId, data: PhysicalProductItemUpdateType) =>
    postPhysicalProductFetcher(getPhysicalProductItemPostPath(storeId), data)
  const updatePhysicalProduct = (id: number, data: PhysicalProductItemUpdateType) =>
    putPhysicalProductFetcher(`${PHYSICAL_PRODUCT_ITEM_API}/${id}`, data)
  const deletePhysicalProductItem = (id: number) =>
    deleteFetcher(`${PHYSICAL_PRODUCT_ITEM_API}/${id}`)

  return {
    createProduct,
    updateProduct,
    deleteProductItem,
    createECourse,
    updateECourse,
    deleteECourseItem,
    createPhysicalProduct,
    updatePhysicalProduct,
    deletePhysicalProductItem,
  }
}
